import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Lets the Mutual Funds actions dropdown (on the parent page) ask the consolidated
 * list (a routed child) to reload itself
 */
@Injectable({ providedIn: 'root' })
export class ConsolidatedListRefreshService {
  private readonly refreshRequestedSubject = new Subject<void>();

  /** Emits when the consolidated list should reload. */
  readonly refreshRequested$: Observable<void> =
    this.refreshRequestedSubject.asObservable();

  requestRefresh(): void {
    this.refreshRequestedSubject.next();
  }
}
